<template>
  <svg
    :style="styles"
    :class="svgClass"
    :viewBox="viewBox"
    :height="height"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    preserveAspectRatio="xMidYMid meet"
  >
    <slot />
  </svg>
</template>

<script>
import kebabCase from 'just-kebab-case'

export default {
  name: 'IconBase',
  props: {
    height: {
      type: [Number, String],
      default: () => '1em'
    },
    width: {
      type: [Number, String],
      default: () => '1em'
    },
    styles: {
      type: [Object, Array],
      default: () => []
    },
    viewBox: {
      type: String,
      default: null
    }
  },
  computed: {
    svgClass () {
      if (this.$slots.default) {
        const vNode = this.$slots.default[0]
        return kebabCase(vNode.context.$options.name)
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="sass" scoped>
svg
  vertical-align: middle
</style>



// WEBPACK FOOTER //
// src/components/icons/IconBase.vue